/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  UncontrolledAlert
} from "reactstrap";
import { register, clearMsg } from "../../actions/auth";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { isEmpty, onPhoneKeyUp } from "../../utils/tools";
import Cookies from "js-cookie";
import { getProfile } from "../../actions/user";
class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      pseudonym: "",
      email: "",
      phone: "",
      subscription: false,
      password: "",
      password_confirmation: ""
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidMount() {
    this.props.clearMsg();
    if (Cookies.get("access_token")) {
      this.props.getProfile('auth');

    }
  }

  render() {
    let {
      name,
      pseudonym,
      email,
      phone,
      subscription,
      password,
      password_confirmation
    } = this.state;
    let { loading, errorMsg, errors } = this.props.auth;
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>註冊 - 美南新聞</title>
          {/* <link rel="canonical" href="https://soonbus.com/login" /> */}
        </Helmet>
        <Col lg="5" md="7">
          {errorMsg && (
            <UncontrolledAlert color="danger" fade={false}>
              <span className="alert-inner--text">{errorMsg}</span>
            </UncontrolledAlert>
          )}
          <Card className="shadow border-0">
            <CardHeader className="bg-transparent">
              <h1 className="d-flex justify-content-center align-items-center">
                新用戶註冊
              </h1>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-5">
              <Form onSubmit={this.onSubmit}>
                <FormGroup className="mb-3">
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    onChange={this.onInputChange}
                    value={name}
                    invalid={!!errors.name}
                    placeholder="姓名"
                  />
                </FormGroup>
                <FormGroup className="mb-3">
                  <Input
                    type="text"
                    name="pseudonym"
                    id="pseudonym"
                    onChange={this.onInputChange}
                    value={pseudonym}
                    invalid={!!errors.pseudonym}
                    placeholder="公開暱稱"
                  />
                </FormGroup>
                <FormGroup className="mb-3">
                  <Input
                    type="email"
                    name="email"
                    id="email"
                    onChange={this.onInputChange}
                    value={email}
                    invalid={!!errors.email}
                    placeholder="郵箱"
                  />
                </FormGroup>
                <FormGroup className="mb-3">
                  <Input
                    type="number"
                    name="phone"
                    id="phone"
                    onChange={this.onInputChange}
                    value={phone}
                    invalid={!!errors.phone}
                    placeholder="電話（選填）"
                  />
                </FormGroup>
                <FormGroup>
                  <Input
                    type="password"
                    name="password"
                    id="password"
                    onChange={this.onInputChange}
                    value={password}
                    invalid={!!errors.password}
                    placeholder="密碼"
                  />
                </FormGroup>
                <FormGroup className="mb-3">
                  <Input
                    type="password"
                    name="password_confirmation"
                    id="password_confirmation"
                    onChange={this.onInputChange}
                    value={password_confirmation}
                    invalid={!!errors.password_confirmation}
                    placeholder="確認密碼"
                  />
                </FormGroup>
                <div className="custom-control custom-control-alternative custom-checkbox">
                  <input
                    className="custom-control-input"
                    id=" customCheckLogin"
                    type="checkbox"
                    name="subscription"
                    value={subscription}
                    onChange={this.onInputChange}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor=" customCheckLogin"
                  >
                    <span className="text-muted">訂閱美南新聞</span>
                  </label>
                </div>
                <div className="text-center">
                  <Button
                    className="my-4 col-12"
                    color="danger"
                    type="submit"
                    disabled={loading}
                  >
                    立即註冊
                  </Button>
                </div>
              </Form>
              <Row className="mt-3">
                <Col className="d-flex justify-content-center">
                  <Link className="text-light text-center" to="login">
                    <small>已有帳號，請登錄</small>
                  </Link>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }
  onInputChange(e) {
    // if (e.target.name === 'phone') {
    //   e.target.value = onPhoneKeyUp(e.target.value);
    // }
    if (e.target.name === "subscription") {
      this.setState({
        subscription: !this.state.subscription
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value
      });
    }
  }

  onSubmit(e) {
    e.preventDefault();
    let {
      name,
      pseudonym,
      email,
      phone,
      subscription,
      password,
      password_confirmation
    } = this.state;
    this.props.login(
      name,
      pseudonym,
      email,
      phone,
      subscription,
      password,
      password_confirmation
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: (
      name,
      pseudonym,
      email,
      phone,
      subscription,
      password,
      password_confirmation
    ) =>
      dispatch(
        register(
          name,
          pseudonym,
          email,
          phone,
          subscription,
          password,
          password_confirmation
        )
      ),
    getProfile: params => dispatch(getProfile(params)),
    clearMsg: () => dispatch(clearMsg())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Register);
